import { InventoryPortalRoute } from "@interfaces";
import { RulesMain } from "../modules/RulesMain/RulesMain";
import { pathRulesMain } from "./routes.types";

export const routesRules: InventoryPortalRoute[] = [
  {
    element: <RulesMain />,
    id: "rulesMain",
    path: pathRulesMain,
  },
];

